import React,{useState} from 'react'
import Location from 'react-autosuggest'
import debounce from 'lodash/debounce'
import Request from 'axios-request-handler';
import './AutoComplete.css'
import {withRouter} from 'react-router-dom'
import { Urls } from '../../../Urls';

 export const requestInstance = new Request({
  lockable: false, // if true if you try to make a request when there is a pending one, the second will not be executed
  cancelable: true, // if true if you try to make a request when there is a pending one, the first will be canceled and the new will executed
  errorHandler:(error,method) => {} // function for handling the errors
})
const AutoComplete = ({
    onSelect,
    className='',
    placeholder,
    onChange,
    disable,
    value,
    key,
    inputClassName='',
    id='Autosuggets_Input_id',
    spinnerClassName='',
    BaseUrl=''
}) => {
    const [suggestions, setSuggestions] = useState([])
    const [show, setShow] = useState(false)
 
  

    const onSuggestionsFetchRequested=debounce(({value})=>{
      if(value.length>=3){
      let url=`${Urls.Autocomplete.Get.getlist}?suggest=${value}&limit=20&searchFields=locations`
      requestInstance.setUrl(url) // changes the instance's url
      if(requestInstance.isPending('get')){
        requestInstance.cancel('get')
      }
      setShow(true)
      requestInstance.get() 
      .then(res=>{
        setSuggestions([])
        setSuggestions(res.data.value)
        setShow(false)
      })
      .catch(err=>{
        // setShow(false)
      })
      }
    },500)
    const onSuggestionsClearRequested=()=>{
        setSuggestions([]);
    }
    const getSuggestionValue=(value)=>{
        return value.location_name;
    }
    const renderSuggestion=(value)=>{
        return value.location_name;
    }
    const onSuggestionSelected=(event,
        { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }
     )=>{
        onChange(suggestion.location_name)
        onSelect(suggestion)

    }
    // const shouldRenderSuggestions=(value)=>{
    //   return value.trim().length%3 === 0
    // }
    
    const inputProps={
        value:value,
        onChange:e=>onChange(e.target.value),
        placeholder:placeholder,
        key:key,
        id:id,
        className:inputClassName,
        disabled: disable,

    }
    return (
      <div className="Loader-Container">

                <Location
                suggestions={suggestions}
                onSuggestionsFetchRequested={value=>onSuggestionsFetchRequested(value)}
                onSuggestionsClearRequested={e=>onSuggestionsClearRequested()}
                getSuggestionValue={value=>getSuggestionValue(value)}
                renderSuggestion={value=>renderSuggestion(value)}
                onSuggestionSelected={onSuggestionSelected}
                inputProps={inputProps}
                // theme={theme}
            /> 
      {
        show?  <div className={`Spinner-Container ${spinnerClassName}`}>
          <i className="fa fa-spinner fa-spin custom-spin" aria-hidden="true"></i>
        </div>:
        null
      }
    
            
          </div>
        
            
    )
}


export default withRouter(AutoComplete)
